import { LoadState } from "../../constants/enums";
import { IMessageSequencesState } from "./MessageSequence.types";

export const initialMessageSequenceState: IMessageSequencesState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  steps: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
};
